module.exports = __webpack_public_path__ + "static/media/store_header.3bfae9f4.png";